import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import blogic from "./../../Images/blogic.jpeg"; // Adjust the path as necessary
import { AuthContext } from "./../../ContextApi/ContextApi"; // adjust path
import Navbar from "../../shared/Navbar";

const Home = () => {
  const navigate = useNavigate();
  const {
    firstName,
    userName, // equivalent to agentUserName
    lastName,
    userEmail,
    userMobile,
  } = useContext(AuthContext);

  // const checkWifi = () => {
  //   if (!navigator.onLine) {
  //     alert("Please check your Wi-Fi/Mobile Data Connection");
  //   }
  // };

  return (
    <div>
      <Navbar />
    <div className="Home-container">
      <div className="Home-bigCircle"></div>
      <div className="Home-smallCircle"></div>

      <div className="Home-centerizedView">
        <div className="Home-authBox">
          <img
            src={blogic}
            alt="Logo"
            className="Home-logo"
          />
          <h2 className="Home-title">Welcome {firstName}</h2>

          <button
            className="Home-PinkButton"
            onClick={() =>
              navigate("/collect", {
                state: {
                  firstName: firstName,
                  agentUserName: userName,
                },
              })
            }
          >
            COLLECT
          </button>

          <button
            className="Home-BlueButton"
            onClick={() =>
              navigate("/report", {
                state: {
                  firstName: firstName,
                  username: userName,
                },
              })
            }
          >
           TOTAL COLLECTION REPORT
          </button>
  
          <button
      className="Home-GreenButton"
      onClick={() =>
        navigate("/add-account", {
          state: {
            firstName: firstName,
            username: userName,
          },
        })
      }
    >
      ADD NEW ACCOUNT
    </button>
    <button
      className="Home-OrangeButton"
      onClick={() =>
        navigate("/new-account", {
          state: {
            firstName: firstName,
            username: userName,
          },
        })
      }
    >
      NEW ACCOUNTS REPORT
    </button> 
  <button
    className="Home-LightBlueButton"
    onClick={() =>
      navigate("/view-old-new-accounts", {
        state: {
          firstName: firstName,
          username: userName,
        },
      })
    }
  >
    VIEW ALL ACCOUNTS
  </button>

        </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
